import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice";
import schoolParticipantsReducer from "./features/schoolParticipantsSlice";
import parentStudentsReducer from "./features/parentStudentsSlice";
import screenRecordingReducer from "./features/screenRecordingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    schoolParticipants: schoolParticipantsReducer,
    parentStudents: parentStudentsReducer,
    screenRecording: screenRecordingReducer,
  },
});
